import { motion } from "motion/react";
import joswinImg from "../assets/joswin.png";
import nikitaImg from "../assets/nikita.jpg";

const team = [
  {
    name: "Nikita Somani",
    role: "Co-Founder",
    image: nikitaImg,
  },
  {
    name: "Joswin D'Souza",
    role: "Co-Founder",
    image: joswinImg,
    scale: 1.25,
    offsetY: '-9%',
  },
];


export default function CoFounders() {
  return (
    <section className="py-24 bg-black relative z-10" id="team">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-heading italic text-white tracking-tight">
            Meet The Co-Founders
          </h2>
        </motion.div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-12 md:gap-24">
          {team.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
              className="relative group w-full max-w-[280px]"
            >
              <div className="relative overflow-hidden border-none outline-none rounded-sm" style={{ height: '420px' }}>
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top duration-700"
                  style={{
                    transform: `scale(${member.scale || 1}) translateY(${member.offsetY || '0%'})`,
                    transformOrigin: 'center top',
                    maskImage: 'radial-gradient(ellipse at 50% 30%, black 20%, transparent 80%)',
                    WebkitMaskImage: 'radial-gradient(ellipse at 50% 30%, black 20%, transparent 80%)'
                  }}
                />
                {/* Gradient Overlays for extra blending */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent pointer-events-none" />
                <div className="absolute inset-0 shadow-[inset_0_0_60px_rgba(0,0,0,1)] pointer-events-none" />
              </div>

              <div className="mt-6 text-center">
                <h3 className="text-2xl font-medium text-white mb-1.5">
                  {member.name}
                </h3>
                <p className="text-base text-white/70 font-light tracking-wide">
                  {member.role}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
